/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as emotion from "emotion";
import {COLORS} from "@res/colors";
import {RoutingModule} from "@intuitionrobotics/thunderstorm/frontend";
import {padding_rl_sm} from "@styles/styles";
import {ICONS} from "@res/icons";
import * as React from "react";
import {CSSProperties, useContext} from "react";
import {AutoComplete} from "../widget/AutoComplete";
import {DB_Patient} from "@app/app-shared/patient";
import {PARAM_CONTACT_ID, Route_Messages} from "../../Routes";
import {PARAM_PATIENT} from "@modules/UserPreferencesModule";
import {PatientsContext} from "./patients/PatientsContext";
import {filterInstances} from "@intuitionrobotics/ts-common";
import {getUserOrgRoles} from "@modules/utils";
import {ID_ALL, messagingRoles, OrgRoleLevel} from "@app/app-shared/permission";
import {useLocation} from "react-router-dom";
import {navigateToPatientPage} from "@modules/PatientDataModule";

const searchWrapperStyle = emotion.css({
    width: 400,
    height: 25,
    borderBottom: 'solid',
    borderWidth: '1px',
    borderColor: COLORS.neutral_gray_1,
    justifyContent: 'space-between',
    boxSizing: "border-box"
});

const searchInputStyle: CSSProperties = {
    fontSize: 16,
    fontFamily: 'Inter-Regular',
    outline: 'none',
    boxSizing: "border-box",
    paddingRight: 8,
    height: 25,
    paddingLeft: 0,
    borderRadius: 0,
    overflowX: "clip"
};

const selectionStyle: CSSProperties = {
    position: 'absolute',
    // TODO: Replace this?
    top: 26,
    left: -8,
    backgroundColor: COLORS.white,
    // Same width as wrapper.
    width: 400,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: COLORS.grays_2,
    borderRadius: 2,
    paddingTop: 5,
    paddingBottom: 5,
    boxSizing: "border-box",
    boxShadow: "rgba(0, 0, 0, 0.19) 0px 2px 4px 0px",
    maxHeight: 200,
    overflowY: "auto",
    zIndex: 20
};

export function PatientSearchBar() {
    const {patients} = useContext(PatientsContext);
    const allPatients = filterInstances(Object.values(patients));

    const {search} = useLocation();
    const queryParams = new URLSearchParams(search);
    const selectedPatientId = queryParams.get(PARAM_PATIENT);

    return <div className={`ll_h_c clickable ${searchWrapperStyle} ${padding_rl_sm}`}>
        <AutoComplete<DB_Patient>
            id={'general-patient-autocomplete'}
            placeholder={'Search by customer'}
            labelResolver={patient => `${patient.name} - ${patient.unitId}`}
            options={allPatients}
            onSelected={patient => {
                if (patient._id === selectedPatientId)
                    return;

                const userOrgRoles = getUserOrgRoles();
                const userOrgRole = userOrgRoles[ID_ALL] || userOrgRoles[patient.organizationId] || [];
                if (userOrgRole.find(role => role === OrgRoleLevel.USER_DATA))
                    navigateToPatientPage(patient);
                else if (userOrgRole.find(role => messagingRoles.includes(role)))
                    RoutingModule.goToRoute(Route_Messages, {[PARAM_CONTACT_ID]: patient.contactId});
            }}
            width={"50%"}
            inputStyle={searchInputStyle}
            selectionStyle={selectionStyle}
        />
        <div style={{width: 16}}>
            {ICONS.search(COLORS.grays_dark, 16)}
        </div>
    </div>;
}
